import Vue from "vue";
import money from "v-money";
import App from "./App.vue";
import router from "./router";
import BootstrapVue from "bootstrap-vue";
import Snotify from "vue-snotify"; // 1. Import Snotify
import store from "./store";
import ApiService from "@/common/api.service.js";
// import AppLayout from "@/layouts/App.vue";
import DefaultLayout from "@/layouts/Default.vue";
// import "./registerServiceWorker";
import SvgFiller from "vue-svg-filler";

Vue.component("svg-filler", SvgFiller);
Vue.use(Snotify);
// Vue.use(money, { precision: 0 });

Vue.use(BootstrapVue);
Vue.use(money, { precision: 0, prefix: "$" });

Vue.config.productionTip = false;
ApiService.init(store);

// Vue.component("app-layout", AppLayout);
Vue.component("default-layout", DefaultLayout);

const Store = store;
Vue.directive("can", {
  bind(el, binding) {
    const user = Store.state.auth.user;
    if (user.Rol.permissions.indexOf(binding.value) == -1) {
      el.style.display = "none";
    }
  }
});

Vue.mixin({
  methods: {
    replaceAll(target, search, replacement) {
      return `${target}`.split(search).join(replacement);
    },
    money: n => {
      var c = 0,
        d = ",",
        t = ".",
        s = n < 0 ? "-" : "",
        i = String(parseInt((n = Math.abs(Number(n) || 0).toFixed(c)))),
        j = (j = i.length) > 3 ? j % 3 : 0;
      return (
        s +
        (j ? i.substr(0, j) + t : "") +
        i.substr(j).replace(/(\d{3})(?=\d)/g, `$1${t}`) +
        (c
          ? d +
            Math.abs(n - parseInt(i))
              .toFixed(c)
              .slice(2)
          : "")
      );
    },

    formatDate: date => {
      let d = new Date(date),
        month = `${d.getMonth() + 1}`,
        day = `${d.getDate()}`,
        year = d.getFullYear();

      if (month.length < 2) month = `0${month}`;
      if (day.length < 2) day = `0${day}`;

      return [year, month, day].join("-");
    },

    overflowText: (text, char_counter = 50) => {
      if (text.length > char_counter) {
        return `${text.substr(0, 5)}...${text.substr(-5)}`;
      }

      return text;
    },
    paginate: (page, paginate) => {
      if (!paginate.to) {
        return [];
      }
      const offset = 5;
      let from = paginate.current_page - offset;
      if (from < 1) {
        from = 1;
      }

      let to = from + offset * 2;
      if (to >= paginate.last_page) {
        to = paginate.last_page;
      }

      const pagesArray = [];
      while (from <= to) {
        pagesArray.push(from);
        from++;
      }
      return pagesArray;
    },

    showData(miner, key) {
      const data = miner[key];

      const type = miner.type_miner;
      const unitName = type ? type.unitName : "TH/S";
      const perType = type ? type.units : 1;
      if (!data) return 0;

      try {
        (data * perType) / 1000;
      } catch (e) {
        return;
      }

      const number = Math.floor(((data * perType) / 1000) * 100) / 100;
      // number = this.money(number, 2, '.', ',');

      return `${number} ${unitName}`;
    },

    round(number, key) {
      return Math.floor(number * 10 ** key) / 10 ** key;
    },

    toHours(minutes) {
      return Math.ceil(minutes / 60);
    },

    printHtml(html) {
      const mywindow = window.open("", "PRINT", "height=400,width=600");

      mywindow.document.write(
        `<html><head><title>${document.title}</title>
        <style>
         @page {
          size: 5cm 9cm;
          margin: 0cm;
         }
        </style>`
      );
      mywindow.document.write("</head><body >");
      mywindow.document.write(html);
      mywindow.document.write("</body></html>");

      mywindow.document.close(); // necessary for IE >= 10
      mywindow.focus();

      mywindow.print();
      mywindow.close();
    }
  }
});

const vue = new Vue({
  // i18n,
  store,
  router,
  render: h => h(App)
}).$mount("#app");
ApiService.setVue(vue);



// WEBPACK FOOTER //
// ./src/main.js